(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-get-marketplace-wallet-paid.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-get-marketplace-wallet-paid.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  WALLET_PLAYER
} = svs.components.tipsen.wallet.walletType;
const {
  drawStates
} = svs.components.marketplaceRetailAdminData.games.helpers;
const useGetMarketplaceWalletPaid = () => {
  const wallet = useSelector(selectActiveWallet);
  if (!wallet || wallet.type === WALLET_PLAYER) {
    return false;
  }
  const status = wallet.meta.activatedDrawStatus;

  if (status && status >= drawStates.CLOSED) {
    return true;
  }
  return false;
};
setGlobal('svs.components.tipsen.hooks.useGetMarketplaceWalletPaid', useGetMarketplaceWalletPaid);

 })(window);